/**
 * Set up routing for all Course views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import course views
import AdminCourseList from './views/AdminCourseList.js.jsx';
import AdminCreateCourse from './views/AdminCreateCourse.js.jsx';
import AdminSingleCourse from './views/AdminSingleCourse.js.jsx';
import AdminUpdateCourse from './views/AdminUpdateCourse.js.jsx';

class CourseAdminRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <YTRoute role="admin" exact path="/admin/content-management/courses" component={AdminCourseList}/>
        <YTRoute role="admin" exact path="/admin/content-management/courses/new" component={AdminCreateCourse}/>
        <YTRoute role="admin" exact path="/admin/content-management/courses/:courseId" component={AdminSingleCourse}/>
        <YTRoute role="admin" exact path="/admin/content-management/courses/:courseId/update-course" component={AdminUpdateCourse}/>
      </Switch>
    )
  }
}

export default CourseAdminRouter;



// WEBPACK FOOTER //
// modules/course/CourseAdminRouter.js.jsx